import { DataTableColumn, textColumn } from '../../shared/components/DataTable'
import { StrategicImperative } from '../../shared/queries/strategicImperatives'

export type StrategicImperativeColumnId = 'name'

export const STRATEGIC_IMPERATIVE_COLUMNS: DataTableColumn<StrategicImperative, StrategicImperativeColumnId>[] = [
    textColumn('name', 'Title', (strategicImperative: StrategicImperative) => strategicImperative.name, {
        width: 1000,
    }),
]

export const getStrategicImperativeSearchValues = (strategicImperative: StrategicImperative) => ({
    name: strategicImperative.name,
})
